module.exports = __webpack_public_path__ + "static/media/bg-intro-mobile.42f40453.png";